import React, {FC} from "react";
import {InitiatorName, Link, NotificationHeader, NotificationMessage, ProjectTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

const declOfNum = (n: number, titles: string[]) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
}

export const NotificationLike: FC<{item: any}> = ({item}) => {

    const {
        notificationTitle,
        initiator: initiatorTop,
        actions,
        mainRow,
        rowCount
    } = item;

    const firstLike = actions[0]?.likeInfo;
    const initiator = firstLike?.initiator;
    const entity = firstLike?.entityInfo;
    const { t } = useTranslation()

    if (!initiator) return null;

    const linkProps = entity?.entityType === 'card'
      ? {
          onClick: (e: any) => {
                const service = actions[0]?.service
                let baseUrl: string | undefined = ''

                switch (service) {
                    case 'kids':
                        baseUrl = process.env.REACT_APP_URL_KIIIDS_ART
                        break
                    default:
                        baseUrl = process.env.REACT_APP_URL_ARTZ_SHOP
                        break
                }
                 
              window.open(`${baseUrl}/card/${entity?.entityId}`, '_blank')

          },
      }
      : entity?.entityType === 'team'
      ? {
          to: CreateLinkTo.team(entity?.entityId)
      }
      : {
          to: CreateLinkTo.project(entity?.entityId)
      }



    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {firstLike?.isAuthorized ? (
                    <Link to={CreateLinkTo.designer(initiator?.accountId)}>
                        <InitiatorName>
                            {initiatorTop?.displayedName}
                        </InitiatorName>
                    </Link>)
                : (
                    <InitiatorName>
                        {initiatorTop?.displayedName}
                    </InitiatorName>
                )}
            {' '}
            {mainRow && rowCount > 0 ? t(`notifications.row_${declOfNum(rowCount, ['count', 'counts', 'count'])}`, { count: rowCount }) : null}
            {notificationTitle}
            {' '}
            {/*@ts-ignore*/}
            <Link {...linkProps}>
                <ProjectTitle>
                    {entity?.entityTitle}
                </ProjectTitle>
            </Link>
        </NotificationMessage>
    </NotificationHeader>
}import React, {FC} from "react";
import {InitiatorName, Link, NotificationHeader, NotificationMessage, ProjectTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import {useTranslation} from "react-i18next";

const declOfNum = (n: number, titles: string[]) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[(n % 10 < 5) ? n % 10 : 5]];
}

export const NotificationLike: FC<{item: any}> = ({item}) => {

    const {
        notificationTitle,
        initiator: initiatorTop,
        actions,
        mainRow,
        rowCount
    } = item;

    const firstLike = actions[0]?.likeInfo;
    const initiator = firstLike?.initiator;
    const entity = firstLike?.entityInfo;
    const { t } = useTranslation()

    if (!initiator) return null;

    const linkProps = entity?.entityType === 'card'
      ? {
          onClick: (e: any) => {
                const service = actions[0]?.service
                let baseUrl: string | undefined = ''

                switch (service) {
                    case 'kids':
                        baseUrl = process.env.REACT_APP_URL_KIIIDS_ART
                        break
                    default:
                        baseUrl = process.env.REACT_APP_URL_ARTZ_SHOP
                        break
                }
                 
              window.open(`${baseUrl}/card/${entity?.entityId}`, '_blank')

          },
      }
      : entity?.entityType === 'team'
      ? {
          to: CreateLinkTo.team(entity?.entityId)
      }
      : {
          to: CreateLinkTo.project(entity?.entityId)
      }



    return <NotificationHeader gx={8}>
        <NotificationMessage>
            {firstLike?.isAuthorized ? (
                    <Link to={CreateLinkTo.designer(initiator?.accountId)}>
                        <InitiatorName>
                            {initiatorTop?.displayedName}
                        </InitiatorName>
                    </Link>)
                : (
                    <InitiatorName>
                        {initiatorTop?.displayedName}
                    </InitiatorName>
                )}
            {' '}
            {mainRow && rowCount > 0 ? t(`notifications.row_${declOfNum(rowCount, ['count', 'counts', 'count'])}`, { count: rowCount }) : null}
            {notificationTitle}
            {' '}
            {/*@ts-ignore*/}
            <Link {...linkProps}>
                <ProjectTitle>
                    {entity?.entityTitle}
                </ProjectTitle>
            </Link>
        </NotificationMessage>
    </NotificationHeader>
}